import { useMemo } from 'react';
import type { AppContext__CurrentUser } from '~/contexts';
import { useAppContext, type AppContext__Network } from '~/contexts';
import { isNavItemVisible, useNavItems, type NavItemConfig } from './navItems';

export const resolveLandingPath = (
  items: NavItemConfig[],
  network: AppContext__Network,
  user: AppContext__CurrentUser,
) => items.find((item) => isNavItemVisible(item, network, user))?.to ?? '/dashboard';

export const useLandingPath = (network?: AppContext__Network) => {
  const { currentNetwork, currentUser } = useAppContext();
  const items = useNavItems();
  const target = network ?? currentNetwork;

  return useMemo(
    () => resolveLandingPath(items, target, currentUser),
    [currentUser, items, target],
  );
};
